import { Typography } from "@mui/material"
import { SubtitleProps } from "./types"
import { SubtitleStyled } from "./subtitle.styles"
import { LightButton } from "../../../../components/button/button"

const Subtitle: React.FC<SubtitleProps> = ({ title, showButton, buttonLabel, buttonAction }) => {
    return (
        <SubtitleStyled>
            <Typography className="subtitle">{title}</Typography>
            {showButton && <LightButton onClick={buttonAction}>{buttonLabel}</LightButton>}
        </SubtitleStyled>
    )
}

export default Subtitle